import gql from "graphql-tag";

const soalanLazimPublicList = gql`
  query soalanLazimListPublic {
    soalanLazimListPublic
  }
`;

const viewsoalanLazim = gql`
  query soalanLazimView($id: Float!) {
    soalanLazimView(id: $id) {
      id
      jenis
      tajuk
      kandungan
      status
      lampiran
      lampiran_meta
      oid
    }
  }
`;

export { soalanLazimPublicList, viewsoalanLazim };
